export const PRE_CHECK = "PRE_CHECK";
export const TIMEZONE = "TIMEZONE";
export const APP_BUSY = "APP_BUSY";
export const ACCOUNT_PROPERTIES = "ACCOUNT_PROPERTIES";
export const ACCOUNT_BUSY = "ACCOUNT_BUSY";
export const SELECTED_ACCOUNT_ID = "SELECTED_ACCOUNT_ID";
export const ACCOUNT_UPDATE_BUSY = "ACCOUNT_UPDATE_BUSY";
export const APP_CONFIG = "APP_CONFIG";
